import { useQuery } from "@tanstack/react-query";
import { Form, Input, Select } from "antd";
import { queryApi, requestApi } from "../../store/actions/common";
import { useEffect } from "react";
import CustomSelect from "../hoc/CustomSelect";

function RelationFieldChild({ item, onChange, value, form }) {
  const dependsOnValue = Form.useWatch(item.dependsOn, form);

  const { data, isLoading: isPending } = useQuery({
    queryKey: [
      item.collectionName,
      "query",
      !!item.dependsOn ? dependsOnValue : "",
    ],
    queryFn: () =>
      queryApi(
        `manage/attributes/query_${
          item.inputType === "relation" ? "table" : "attribute"
        }${
          item.inputType === "relation"
            ? `?table=${item.collectionName}`
            : `?levelPath=${item.collectionName}${
                !!item.dependsOn ? `&name=${dependsOnValue}` : ""
              }`
        }`,
        "GET",
      ),
    enabled: !!item.customOptions
      ? false
      : !!item.dependsOn
        ? !!dependsOnValue
        : true,
    staleTime: Infinity,
    gcTime: 0,
  });

  const options = !!item.customOptions
    ? item.customOptions
    : !!data && Array.isArray(data)
      ? item.inputType === "relation"
        ? data
        : data?.map((i) => ({ label: i.name, value: i.name }))
      : [];

  useEffect(() => {
    const isEdit = form.getFieldValue("isFormEdit");
    if (!isEdit && Array.isArray(options) && options.length === 1) {
      form.setFieldValue(item.title, options[0].value);
    }
    // else {
    //   form.(item.title);
    // }
  }, [options]);

  return (
    <>
      <CustomSelect
        loading={isPending}
        onChange={(v, option) => {
          if (!!item.customOnChange) {
            item.customOnChange(option);
          }
          onChange(v);
        }}
        value={value}
        optionFilterProp="label"
        showSearch
        mode={item.relationType === "multiple" ? "multiple" : undefined}
        options={
          item.allowOther && options.length > 0
            ? [...options, { label: "Other", value: "other" }]
            : options
        }
      />
      {value === "other" && (
        <Form.Item
          name={["collection", `${item.collectionName}_other`]}
          style={{ marginBottom: 0, marginTop: 8 }}
          rules={[
            {
              required: item.required,
              message: `Missing ${item.title}`,
            },
          ]}
        >
          <Input placeholder="Please specify" />
        </Form.Item>
      )}
    </>
  );
}

export default RelationFieldChild;
